__turbopack_context__.v({
  "DateSelectors": "x_tUfW_DateSelectors",
  "KinoklubbPromoContainer": "x_tUfW_KinoklubbPromoContainer",
  "SControlsWrapper": "x_tUfW_SControlsWrapper",
  "SKinoklubb": "x_tUfW_SKinoklubb",
  "SKinoklubbSelectionSvg": "x_tUfW_SKinoklubbSelectionSvg",
  "SProgramWrapper": "x_tUfW_SProgramWrapper",
  "SSelectors": "x_tUfW_SSelectors",
  "SShowWrapper": "x_tUfW_SShowWrapper",
  "withSponsor": "x_tUfW_withSponsor",
});
